import { Box, styled } from "@mui/material";

export const TotalRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

export const ButtonWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
});
